module.exports = __webpack_public_path__ + "img/normal.aeeba268.svg";